<template>
        <v-row justify="center">
            <v-dialog
                v-model="showModal"
                persistent
                max-width="700"
            >
                <v-card>
                    <v-card-title class="headline my-4">
                        ¿Está de seguro de eliminar el trámite del carrito?
                    </v-card-title>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn
                            color="normal"
                            text
                            @click="cancelRemoveItem()"
                        >
                            Cancelar
                        </v-btn>
                        <v-btn
                            color="error"
                            @click="removeItem()"
                        >
                            Eliminar trámite
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-row>
</template>

<script>
    export default {
        name: 'Deteledialog',
        props: ['showModal', 'removeItem', 'cancelRemoveItem']
    };
</script>
